// src/firebaseConfig.ts
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth'
import firebaseConfigData from './firebaseConfig.json'
import { getEnvironment } from './utils/environment'
import { getAnalytics } from 'firebase/analytics'
import { getRemoteConfig } from 'firebase/remote-config'
import { initRemoteConfig } from './firebaseRemoteConfig'

const environment = getEnvironment()
const firebaseConfig = firebaseConfigData[environment]

const firebaseApp = initializeApp(firebaseConfig)

const auth = getAuth(firebaseApp)
const googleProvider = new GoogleAuthProvider()
const microsoftProvider = new OAuthProvider('microsoft.com')
const firebaseAnalytics = getAnalytics(firebaseApp)

const remoteConfig = getRemoteConfig(firebaseApp)
initRemoteConfig(remoteConfig).catch((err) => {
    console.warn('[remoteConfig] Initialization failed', err)
})

export { firebaseApp, auth, googleProvider, microsoftProvider, firebaseAnalytics, remoteConfig }
